export class Visit {
  constructor(
    readonly startAt: Date,
    readonly serviceName: string,
    readonly doctorName: string,
  ) {}
}
